import React, { useState } from 'react'
import Modal from '../../Modal'
import Text from '../../Text'
import Youtube from '../../Youtube'
import Spacer from '../../Spacer'
import CategoryTitle from '../../CategoryTitle'
import Cta from '../../Cta'
import CtaLoading from '../../CtaLoading'
import SimpleBlockContent from '../../SimpleBlockContent'
import CrossIcon from '../../icons/CrossIcon'
import Input from '../../Input'
import styles from './styles.module.css'
import { $neutralGray80, $white } from '../../../styles/colors/primitives'
import { http } from '../../../utils/clientHttp'
import { pushDataLayerEvent } from '../../../utils/dataLayer'



function PictureAndTextWithMailingList({ sideImage, category, theme = {}, title, text, reversed, containImage, imagePosition, ctaTitle, ctaPrimary, modalTitle, modalText, modalCtaText }) {
  // Phase B: the modal-open flag + form field buffers + submit loading are LOCAL
  // component state (was Overmind showSteeringWheelMailingModal /
  // steeringWheelMailingForm — read only here). The submit posts directly through
  // the same /api/addUserToSteeringWheelMailingList endpoint the old
  // steeringWheelMailingFormSubmitted action used, firing the identical
  // newsletter_signup dataLayer event — behavior-preserving.
  const [showModal, setShowModal] = useState(false)
  const [form, setForm] = useState({ name: '', email: '', autocomplete: true })
  const [isLoading, setIsLoading] = useState(false)

  const themeColorValue = theme.title.match(/\d+/) ? Number(theme.title.match(/\d+/)[0]) : null
  const textColor = themeColorValue && themeColorValue > 40 ? $white : $neutralGray80
  const dark = themeColorValue && themeColorValue < 50

  // Runtime/prop-driven values -> inline style (matches former styled `${props}`).
  const sideImageStyle = {
    backgroundImage: sideImage?.src ? `url(${sideImage.src})` : undefined,
    backgroundSize: containImage ? 'contain' : 'cover',
    backgroundPosition: imagePosition ? imagePosition : 'bottom'
  }

  const submit = () => {
    setIsLoading(true)
    http
      .post('/api/addUserToSteeringWheelMailingList', {
        email: form.email,
        firstName: form.name,
      })
      .then((response) => {
        console.log('response', response)
        pushDataLayerEvent('newsletter_signup', {
          list: 'steering_wheel_updates',
          user_data: { email: form.email },
        })
      })
      .catch((e) => {
        console.log('Bad request', e.message)
      })
      .finally(() => {
        setShowModal(false)
        setForm({ name: '', email: '', autocomplete: true })
        setIsLoading(false)
      })
  }

  const extractNameFromEmail = ( email ) => {
    try {
      return email
        .substring(0, email.indexOf('@'))
        .replaceAll('.', ' ')
        .replaceAll('_', ' ')
        .replaceAll(/\s+/g, ' ')
        .replaceAll(/[^a-zA-Z ]/g, '')
        .replaceAll(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
    } catch (e) {
      return ''
    }
  }

  return (
    <div className={styles.wrapper} style={{ backgroundColor: theme.value }}>
      <div className={styles.contentWrapper}>
        <div className={styles.sideImageWrapper}>
          {/* task #67: styled bg fed the resolved descriptor url */}
          <div className={styles.sideImage} style={sideImageStyle} />
        </div>
        <div className={reversed ? `${styles.textWrapper} ${styles.reversed}` : styles.textWrapper}>
          {category && category.title.length > 0 && <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>}
          {title && <div>
            <Spacer size={16} />
            <div style={{ color: textColor }}><Text type="H1">{title}</Text></div>
            </div>}
          <Spacer size={32} />
          <div style={{ color: textColor }}>
            {text && <SimpleBlockContent blocks={text} />}
          </div>
          <Spacer size={64} />
            <div className={styles.ctas}>
              <Cta title={ctaTitle} primary={ctaPrimary} onClick={() => setShowModal(true)} />
            </div>
          <Spacer size={160} />
        </div>

        <Modal show={showModal} onClose={() => setShowModal(false)} aria-label="Mailing list signup">
          <div className={styles.modalWrapper}>
            <Spacer size={32} />
            <button className={styles.modalCloseButton} onClick={() => setShowModal(false)} aria-label="Close dialog" type="button">
              <CrossIcon aria-hidden="true" />
            </button>
            <Text type='h3'>{modalTitle}</Text>
            <Spacer size={8} />
            <Text type='body-short-1'>{modalText}</Text>
            <Spacer size={40} />
            <form className={styles.form} onSubmit={(e) => {
              submit()
              e.preventDefault()
            }}>
              <Input
                dark={true}
                small
                value={form.email}
                required
                placeholder="Your email address"
                type="email"
                aria-label="Email address"
                onChange={(e) => {
                  const value = e.target.value
                  setForm((f) => ({
                    ...f,
                    email: value,
                    name: f.autocomplete ? extractNameFromEmail(value) : f.name,
                  }))
                }}
              />
              <Spacer size={8} />
              <Input
                dark={true}
                small
                value={form.name}
                placeholder="Your name (optional)"
                aria-label="Your name (optional)"
                onChange={(e) => {
                  const value = e.target.value
                  setForm((f) => ({ ...f, name: value, autocomplete: false }))
                }}
              />
              <Spacer size={40} />
              <CtaLoading
                title={modalCtaText}
                dark
                type="submit"
                isLoading={ isLoading }
                disabled={ isLoading }
              />
            </form>
            <Spacer size={32} />
          </div>
        </Modal>

      </div>
    </div>
  )
}

export default PictureAndTextWithMailingList
